export function Note() {
    const name = "annotation";
    const fields = {
        "filename":"filename",
        "subject":"subject",
        "notetext":"notetext",
        "createdon":"createdon",
        "isdocument":"isdocument",
        "documentbody":"documentbody",
        "createdby":"createdby"
    };
    return{name, fields}
}